import React, { useEffect } from 'react';
import { getCategories, getProducts } from '../dataManager';

export default function SitemapPage({ navigateTo }) {
  const categories = getCategories();
  const products = getProducts();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sitemapStyles = {
    container: {
      padding: '6rem 4rem',
      maxWidth: '1400px',
      margin: '0 auto',
      minHeight: '80vh',
      background: 'var(--bg-primary)'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '4rem',
      marginTop: '4rem'
    },
    section: {
      background: '#fff',
      padding: '2.5rem',
      borderRadius: '16px',
      border: '1px solid var(--border-color)',
      boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
      transition: 'transform 0.3s ease'
    },
    sectionTitle: {
      fontFamily: 'var(--ff-display)',
      fontSize: '1.8rem',
      color: 'var(--accent-color)',
      marginBottom: '1.5rem',
      borderBottom: '2px solid var(--border-color)',
      paddingBottom: '0.5rem',
      textTransform: 'uppercase',
      letterSpacing: '1px'
    },
    list: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    item: {
      padding: '0.8rem 0',
      borderBottom: '1px solid rgba(0,0,0,0.05)',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '0.8rem',
      fontSize: '1.05rem',
      color: 'var(--text-main)'
    }
  };

  return (
    <div style={sitemapStyles.container}>
      <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <div className="hero-badge" style={{ marginBottom: '1rem' }}>Navigation Guide</div>
        <h1 className="section-title">Website <span style={{ color: 'var(--accent-color)' }}>Sitemap</span></h1>
        <p className="section-subtitle">A comprehensive map of all pages and products available on N.D.Tools</p>
      </div>

      <div style={sitemapStyles.grid}>
        {/* Main Navigation */}
        <div style={sitemapStyles.section} className="sitemap-card">
          <h3 style={sitemapStyles.sectionTitle}>Main Navigation</h3>
          <ul style={sitemapStyles.list}>
            {[
              { name: 'Home', target: 'home' },
              { name: 'About Us', target: 'about' },
              { name: 'Industrial Catalog', target: 'products' },
              { name: 'Machine Gallery', target: 'gallery' },
              { name: 'E-Brochure', target: 'ebrochure' },
              { name: 'Contact Support', target: 'contact' },
              { name: 'Admin Portal', target: 'admin' }
            ].map((link, i) => (
              <li 
                key={i} 
                style={sitemapStyles.item} 
                onClick={() => navigateTo(link.target)}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-color)'; e.currentTarget.style.paddingLeft = '0.5rem'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-main)'; e.currentTarget.style.paddingLeft = '0'; }}
              >
                <span style={{ color: 'var(--accent-color)', fontWeight: 'bold' }}>→</span> {link.name}
              </li>
            ))}
          </ul>
        </div>

        {/* Product Categories */}
        <div style={sitemapStyles.section} className="sitemap-card">
          <h3 style={sitemapStyles.sectionTitle}>Machine Categories</h3>
          <ul style={sitemapStyles.list}>
            {categories.map((cat, i) => (
              <li 
                key={i} 
                style={sitemapStyles.item} 
                onClick={() => navigateTo('products', cat.id)}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-color)'; e.currentTarget.style.paddingLeft = '0.5rem'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-main)'; e.currentTarget.style.paddingLeft = '0'; }}
              >
                <span style={{ color: 'var(--accent-color)', fontWeight: 'bold' }}>→</span> {cat.name}
              </li>
            ))}
            {categories.length === 0 && <li style={{ opacity: 0.5 }}>No categories found</li>}
          </ul>
        </div>

        {/* Popular Machines */}
        <div style={sitemapStyles.section} className="sitemap-card">
          <h3 style={sitemapStyles.sectionTitle}>Popular Machines</h3>
          <ul style={sitemapStyles.list}>
            {products.slice(0, 10).map((prod, i) => (
              <li 
                key={i} 
                style={sitemapStyles.item} 
                onClick={() => navigateTo('productDetails', prod)}
                onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--accent-color)'; e.currentTarget.style.paddingLeft = '0.5rem'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-main)'; e.currentTarget.style.paddingLeft = '0'; }}
              >
                <span style={{ color: 'var(--accent-color)', fontWeight: 'bold' }}>→</span> {prod.name}
              </li>
            ))}
            {products.length > 10 && (
              <li 
                style={{ ...sitemapStyles.item, opacity: 0.7, fontStyle: 'italic' }}
                onClick={() => navigateTo('products')}
              >
                View all {products.length} products...
              </li>
            )}
            {products.length === 0 && <li style={{ opacity: 0.5 }}>No products found</li>}
          </ul>
        </div>
      </div>

      <div style={{ marginTop: '5rem', textAlign: 'center', opacity: 0.6, fontSize: '0.9rem' }}>
        <p>Technical Sitemap (XML) for search engines available at <a href="/api/sitemap" target="_blank" style={{ color: 'var(--accent-color)', textDecoration: 'none' }}>/api/sitemap</a></p>
      </div>
    </div>
  );
}
